import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    listings: [],
    rocketshipAccounts: [],
});

const overviewFilter = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_SUCCESS:
            return assign({}, state, payload);
        default:
            return state;
    }
};

export default overviewFilter;
